const accordions = document.querySelectorAll('.accordion_section')
if (accordions) {
  const header = document.querySelector('header')
  Array.prototype.forEach.call(accordions, (accSection) => {
    const accordCards = accSection.querySelectorAll('.accordion-item')
    const accordRight = accSection.querySelectorAll('.right-wrap')
    if (accordCards) {
      Array.prototype.forEach.call(accordCards, (card) => {
        const accordButton = card.querySelector('button')
        accordButton.addEventListener('click', () => {
          Array.prototype.forEach.call(accordCards, (card) => {
            card.classList.remove('active')
          })
          card.classList.add('active')
          const collapser = card.querySelector('.accordion-collapse')
          const accIndex = parseInt(collapser.getAttribute('data-index'))
          if (accordRight) {
            Array.prototype.forEach.call(accordRight, (accRight) => {
              accRight.classList.remove('active')
              let rightIndex = parseInt(accRight.getAttribute('data-index'))
              if (rightIndex === accIndex) {
                accRight.classList.add('active')
              }
              if (collapser.classList.contains('show')) {
                accRight.classList.remove('active')
              }
            })
          }
        })
      })
    }
    let videoWrappers = accSection.querySelectorAll('.video-wrapper')
    if (videoWrappers) {
      Array.prototype.forEach.call(videoWrappers, (videoWrapper) => {
        const videoOpen = videoWrapper.querySelector('.thumbnail img')
        const popupWrapper = videoWrapper.querySelector('.iframe-wrapper')
        const videoClose = popupWrapper.querySelector('.close-button')
        const iframeInner = popupWrapper.querySelector('.iframe-inner')
        iframeInner.remove()          
        const iframeElem = document.createElement('iframe')
        let videoId = popupWrapper.querySelector('.video-id-wrapper').getAttribute('data-id')
        videoOpen.addEventListener('click', () => {
          popupWrapper.appendChild(iframeInner)
          accSection.classList.add('open')
          header.classList.add('zindex-remove')
          videoWrapper.classList.add('open')

          iframeElem.setAttribute('width', '560')
          iframeElem.setAttribute('height', '315')
          iframeElem.setAttribute('src', `https://www.youtube.com/embed/${videoId}?autoplay=1`)
          iframeElem.setAttribute('title', 'YouTube video player')
          iframeElem.setAttribute('frameborder', '0')
          iframeElem.setAttribute('autoplay', '1')
          iframeElem.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture')
          iframeElem.setAttribute('allowfullscreen', '')
      
          var tag = document.createElement('script');
          tag.src = "https://www.youtube.com/player_api";
          var firstScriptTag = document.getElementsByTagName('script')[0];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
          var player;
          function onYouTubePlayerAPIReady() {
            player = new YT.Player('.video-popup-frame', {
              height: '360',
              width: '640',
              videoId: videoId,
              autoplay: 1
            });
          }
          iframeInner.appendChild(iframeElem)
        })
        popupWrapper.addEventListener('click', (e) => {
          if (e.target !== iframeElem) {
            header.classList.remove('zindex-remove')
            videoWrapper.classList.remove('open')
            iframeInner.remove()
            accSection.classList.remove('open')
          }
        })
      })
    }
  })
}